import Cookies from "js-cookie";
import HCLDX from "@system/config/hcldx";
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import Helper from "./Helper";
import Constants from "src/helper/Constants";
import liveAuth from "./liveAuth";
import { isNumber } from "underscore";
import store from "src/storeWire";
import { system_notification } from "src/store/slice/system";
const { userInfoKey, speedBoats, siteUser, currencyType, SELECTED_APAC_CURRENCY, SELECTED_JAPAN_CURRENCY } = Constants
// import i18n from "i18next";
import translate from 'src/locales/en/translation.json'

class System {

  static avUserInfoData = {
    speedBoatAbbr: this.getCoockieObjVal(userInfoKey.SPEEDBOAT),
    speedBoatName: this.getCoockieObjVal(userInfoKey.SPEEDBOATNAME),
    speedBoatNameLower: Helper.toLowerCase(this.getCoockieObjVal(userInfoKey.SPEEDBOATNAME)),
    userName: this.getCoockieObjVal(userInfoKey.USERNAME),
    accountNumber: this.getCoockieObjVal(userInfoKey.ACCOUNTNUMBER),
    userId: this.getCoockieObjVal(userInfoKey.USERID),
    email: this.getCoockieObjVal(userInfoKey.EMAIL),
    billToCountryCode: this.getCoockieObjVal(userInfoKey.BILLCOUNTRYCODE),
    accountName: this.getCoockieObjVal(userInfoKey.ACCOUNTNAME),
    speedboatDescription: this.getCoockieObjVal(userInfoKey.SPEEDBOATDESCRIPTION),
    roles: this.getCoockieObjVal(userInfoKey.ROLES),
    salesOrg: this.getCoockieObjVal(userInfoKey.SALESORG),
    creditRisk: this.getCoockieObjVal(userInfoKey.CREDITRISK),
    orderBlock: this.getCoockieObjVal(userInfoKey.ORDERBLOCK),
    currentUser: liveAuth.check() ? (this.getCoockieObjVal(userInfoKey.ACCOUNTNUMBER) ? siteUser.CORE : siteUser.WEB) : siteUser.GUEST,
    defaultShipTo: this.getCoockieObjVal(userInfoKey.DEFAULTSHIPTO),
    currentShipTo: this.getCoockieObjVal(userInfoKey.CURRENTSHIPTO),
    isAdmin: this.getCoockieObjVal(userInfoKey.ISADMIN),
  };

  static getCoockieObjVal(key) {
    const avUserInfo = liveAuth.getAvUserInfo() ? liveAuth.getAvUserInfo() : { "firstName": null, "lastName": null, "phoneNumber": null, "speedboat": "A", "userID": null, "email": null }
    let value = "";

    switch (key) {
      case userInfoKey.USERNAME:
        value = avUserInfo.firstName ? avUserInfo.firstName + ' ' + avUserInfo.lastName : "";
        break;
      case userInfoKey.SPEEDBOATNAME:
        value = avUserInfo.speedboat === 'A' ? speedBoats.APAC : speedBoats.JAPAN
        break;
      case userInfoKey.SPEEDBOAT:
        value = avUserInfo[key] ? avUserInfo[key] : 'A';
        break;
      default:
        if (key === userInfoKey.BILLCOUNTRYCODE || key === userInfoKey.ACCOUNTNAME || key === userInfoKey.ACCOUNTNUMBER || key === userInfoKey.SPEEDBOATDESCRIPTION || key === userInfoKey.ROLES || key === userInfoKey.SALESORG || key === userInfoKey.ORDERBLOCK || key === userInfoKey.CREDITRISK || key === userInfoKey.DEFAULTSHIPTO) {
          value = avUserInfo?.account && avUserInfo?.account[key] !== undefined ? avUserInfo.account[key] : '';
        } else {
          value = avUserInfo[key] ? avUserInfo[key] : '';
        }
        break;
    }

    return value;
  }

  static getParams(url = window.location) {
    const params = {};
    new URL(url).searchParams.forEach(function (val, key) {
      if (params[key]) {
        if (!Array.isArray(params[key])) {
          params[key] = [params[key]];
        }
        params[key].push(val);
      } else {
        params[key] = val;
      }
    });
    return params;
  }

  static storageName = {
    // session Storage
    CART_ID_AP: "CART_ID_AP",
    CART_ID_JP: "CART_ID_JP",
    SUCCESS_PAGE: "SUCCESS_PAGE",

    // local Storage
    HCLDX_LOCALHOST_ACTIVATE: "HCLDX_LOCALHOST_ACTIVATE", // not set anywhere only get
    UNIVERSAL_SEARCH_PARAM: "UNIVERSAL_SEARCH_PARAM",
    UNIVERSAL_SEARCH: "UNIVERSAL_SEARCH",
    FLASH_MESSAGE: "FLASH_MESSAGE",
    FLASH_MESSAGE_REMATCH: "FLASH_MESSAGE_REMATCH",
    BOM_UPLOAD_FILE: "BOM_UPLOAD_FILE",
    CART: "CART" + this.avUserInfoData.speedBoatAbbr,
    CART_PRODUCT_DATA: "CART_PRODUCT_DATA",
    PRODUCT_COMPARE: "PRODUCT_COMPARE",
    PRODUCT_COMPARE_API: 'PRODUCT_COMPARE_API__' + this.avUserInfoData.speedBoatNameLower,
    PRODUCT_LISTING_FILTER_BOX_SELECTION: 'ProductListingFilterBoxSelection__' + this.avUserInfoData.speedBoatNameLower,
    PRODUCT_LISTING_SETTINGS: 'PRODUCT_LISTING_SETTINGS',
    ACCOUNT_LINK_SUCCESS_MESSAGE: 'ACCOUNT_LINK_SUCCESS_MESSAGE',
    PRODUCT_LISTING_VIEW: 'PRODUCT_LISTING_VIEW',
    GUEST_SESSION_ID_AP: "GUEST_SESSION_ID_AP",
    GUEST_SESSION_ID_JP: "GUEST_SESSION_ID_JP",
    GUEST_BOM_ID_AP: "GUEST_BOM_ID_AP",
    GUEST_BOM_ID_JP: "GUEST_BOM_ID_JP",
    PAYMENT_ERROR: "PAYMENT_ERROR",
    ORDER_FEEDBACK: "ORDER_FEEDBACK",
    BOM_OPENED: "BOM_OPENED",
    BOM_RENAME: "BOM_RENAME",
    BOM_MULTI_MATCH: "BOM_MULTI_MATCH_SELECTION",
    BOM_NO_MATCH_RESOLVE: "BOM_NO_MATCH_RESOLVE",
    CART_CHECKOUT: "CART_CHECKOUT__" + this.avUserInfoData.speedBoatNameLower,
    CART_CHECKOUT_INITIAL_STEP: "CART_CHECKOUT_STEP_1__" + this.avUserInfoData.speedBoatNameLower,
    CART_CHECKOUT_MID_STEP: "CART_CHECKOUT_STEP_2__" + this.avUserInfoData.speedBoatNameLower,
    CART_CHECKOUT_LAST_STEP: "CART_CHECKOUT_STEP_3__" + this.avUserInfoData.speedBoatNameLower,
    CART_CHECKOUT_PLACE_ORDER: "CART_CHECKOUT_PLACE_ORDER__" + this.avUserInfoData.speedBoatNameLower,
    // Cokkies
    LANGUAGE_KEY: "com.ibm.wps.state.preprocessors.locale.LanguageCookie",
    User_Country: "User_Country",
    CART_COUNT_AP: "CART_COUNT_AP",
    CART_COUNT_JP: "CART_COUNT_JP"
  };

  static getBaseUrl() {
    return this.getUserUrl();
  }

  static getBOMUrl() {
    return process.env.REACT_APP_API_BOM;
  }

  static getDesignHubUrl() {
    return process.env.REACT_APP_API_DESIGN_HUB;
  }

  static getApplicationUrl() {
    return process.env.REACT_APP_API_APPLICATION;
  }

  static getCartUrl() {
    return process.env.REACT_APP_API_CART;
  }

  static getInventoryUrl() {
    return process.env.REACT_APP_API_INVENTORY;
  }

  static getPriceUrl() {
    return process.env.REACT_APP_API_PRICE;
  }

  static getProductUrl() {
    return process.env.REACT_APP_API_PRODUCT;
  }

  static getUserUrl() {
    return process.env.REACT_APP_API_USER;
  }

  static getProfileUrl() {
    return process.env.REACT_APP_API_USER;
  }

  static getOrderUrl() {
    return process.env.REACT_APP_API_ORDER;
  }

  static getReportErrorUrl() {
    return process.env.REACT_APP_API_REPORT_ERROR;
  }

  static getAdminConsoleUrl() {
    return process.env.REACT_APP_API_ADMIN_CONSOLE;
  }

  static redirectToNewark(searchTerm) {
    if (this.avUserInfoData.speedBoatAbbr == speedBoats.apacAbbr) {
      return { link: `https://sg.element14.com/search?st=${searchTerm}`, name: 'Element14 Site' }
    } else {
      return { link: `https://jp.farnell.com/search?st=${searchTerm}`, name: 'Farnell Site' }
    }
  }

  static popup(popup_name, data = []) {
    store.dispatch(system_notification({
      name: popup_name,
      data: data,
    }));
  }


  static getHomepageUrl() {
    return HCLDX.baseURL()
  }

  static getLoginPageUrl() {
    return this.getRedirectionURL("/authenticate/login/");
  }

  static setWindow_avUserInfo_cookie_name() { // need to update based on dx cookie name
    let selectedCurrency = this.avUserInfoData.speedBoatAbbr == speedBoats.apacAbbr ? Cookies.get(SELECTED_APAC_CURRENCY) : Cookies.get(SELECTED_JAPAN_CURRENCY)
    if (selectedCurrency) {
      window.mct = selectedCurrency;
      window.mcs = getSymbolFromCurrency(window.mct);
    }
  }

  static getHelpPageUrl() {
    return 'https://www.avnet.com/wps/portal/us/about-avnet/help/'
  }

  static getPreviousPageUrl() {
    let _url = "";
    const baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    const sBoat = this.avUserInfoData.speedBoatNameLower;
    if (baseUrl && baseUrl.trim() !== "" && sBoat && sBoat.trim() !== "") {
      _url = baseUrl + sBoat
    }
    return _url
  }

  static getPrivacyURL() {
    const url = System.avUserInfoData.speedBoatAbbr === Constants.speedBoats.apacAbbr ? 'https://www.avnet.com/apac/about-avnet/privacy/' : 'https://www.avnet.com/japan/about-avnet/privacy/'

    return url
  }

  static getHelpURL() {
    const URL = System.avUserInfoData.speedBoatAbbr === Constants.speedBoats.apacAbbr ? 'https://www.avnet.com/wps/portal/apac/about-avnet/online-help/' : 'https://www.avnet.com/wps/portal/japan/about-avnet/online-help/shop/'
    return URL
  }

  static getTierParam() {
    return process.env.REACT_APP_TIER_PARAM
  }

  static getRedirectionURL = (url) => {
    let _url = "";
    const baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    const sBoat = Helper.toLowerCase(this.avUserInfoData.speedBoatName);
    if (baseUrl && baseUrl.trim() && sBoat && sBoat.trim() && url) {
      // Check Speedboat URL and this works for NPI and other content tabs
      if (url.includes(sBoat)) {
        const splitUrlArr = url.split(sBoat);
        if (splitUrlArr && splitUrlArr.length > 0) {
          url = splitUrlArr[1];
        }
      }
      _url = baseUrl + sBoat + url;
    }
    return _url;
  };

  static getCurrencyFormat(currencyType) {
    const format = {
      'CHF': 'nb-NB',
      'CZK': 'nb-NB',
      'DKK': 'nb-NB',
      'EUR': 'nl-NL',
      'GBP': 'en-GB',
      'HKD': 'zh-HK',
      'ILS': 'nb-NB',
      'JPY': 'ja-JP',
      'NOK': 'nb-NB',
      'PLN': 'nb-NB',
      'RON': 'rof',
      'SEK': 'nb-NB',
      'TRY': 'tr-TR',
      'ZAR': 'en-ZA'
    };

    return format[currencyType] ? format[currencyType] : 'en-US'
  }

  static isCallFromCart = () => {
    const currentUrl = window.location.pathname;
    const cart = currentUrl.includes("shop")
    return cart ? true : false;
  }

  static checkIsCustomerPrice = (priceList) => {
    if (priceList && priceList[0] && (priceList[0].custPriceInd === true)) {
      return true;
    }
    return false
  }

  static validateDomain = (email) => {
    if (!email) {
      return false;
    }
    if (email.includes('@')) {
      const userDomain = (email.split("@"))[1];
      const domains = Constants.internalUsers
      return domains.some(domain => domain.toLowerCase() === userDomain?.toLowerCase());
    } else {
      return true
    }
  }

  static monitorJSDx = () => {
    try {
      if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS === 'yes') {
        window.BOOMR?.plugins?.SPA?.wait_complete();
        console.log("stop BOOMR.plugins.SPA.wait_complete()");
      }
    } catch (e) {
      console.log('BOOMR event is not initialized')
    }
  }

  static monitorFrameWorkReady = () => {
    try {
      if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS === 'yes' && BOOMR?.plugins?.Continuity) {
        BOOMR.plugins.Continuity.frameworkReady();
        console.log("stop BOOMR.plugins.Continuity.frameworkReady()");
      }
    } catch (e) {
      console.log('BOOMR event is not initialized')
    }
  }

  static getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  static getFormatNumber(params) {
    const { amount, currency = window.mct, symbol = "", maximumFractionDigits = 5, isSymbol = true, isDisplaySymbol = true, roundOff = false } = params;
    let curSymbol = symbol ? symbol : getSymbolFromCurrency(currency)

    if (amount && isNumber(amount) && currency) {
      const isJapan = this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.japanAbbr
      const roundedAmount = roundOff && isJapan ? Math.round(amount) : amount;
      const formatAmount = new Intl.NumberFormat(this.getCurrencyFormat(currency), {
        style: 'currency',
        maximumFractionDigits: isJapan ? roundOff ? 0 : 2 : maximumFractionDigits,
        currency: currency,
        currencyDisplay: "code"
      }).format(roundedAmount).replace(currency, "").trim()

      if ((!isSymbol || !isDisplaySymbol) && formatAmount.includes(currency)) {
        return formatAmount.replace(currency, '')
      }
      return isSymbol ? curSymbol + formatAmount : formatAmount
    }
  }

  static getUserShippingAddress() {
    let { currentShipTo, defaultShipTo } = this.avUserInfoData
    const currentShippingAddressId = currentShipTo ? currentShipTo : defaultShipTo;
    return currentShippingAddressId
  }

  static isCPNAvailableInList = (single_product, selectedCPN) => {
    if (single_product?.CustomerPartNumbers?.length > 0 && single_product?.CustomerPartNumbers.filter(e => e.CPN === selectedCPN).length > 0) {
      return true;
    }
    return false;
  }

  static checkValidQuantity = (single_product, qty) => {
    let res = false;

    let minQty = single_product?.QtyMin;
    let multQty = single_product?.QtyMult

    if (qty >= 0 && qty !== "") {
      if (minQty < multQty && qty % minQty !== 0) {
        res = true;
      }
      else if (minQty && qty < minQty) {
        res = true;
      }
      else if (multQty && qty % multQty !== 0) {
        res = true;
      }
    }

    return res;
  };

  static getCurrentRegionWithType(region, type = "") {
    if (this.avUserInfoData.speedBoatAbbr === region && this.avUserInfoData.currentUser === type) {
      return true
    } else if (this.avUserInfoData.speedBoatAbbr === region && type === "") {
      return true
    }
    return false
  }

  static getFieldType = (field) => {
    const config = Constants.CognitiveSearchFieldConfig;
    return config[field] || config.attributes;
  };

  static getCurrentLanguageKeyForApi = () => {
    const val = (System.avUserInfoData.speedBoatAbbr === Constants.speedBoats.japanAbbr ? (Cookies.get('japanLang') ? Cookies.get('japanLang') : Constants.LanguageCodes["ja-JP"]) : (Cookies.get('apacLang') ? Cookies.get('apacLang') : Constants.LanguageCodes["en-US"]))
    return val?.replace("_", "-")
  }

  static translation = key => {
    const translateKeys = (window.dxLocaleData && window.dxLocaleData[key]) ? window.dxLocaleData[key]?.value : translate[key]
    return translateKeys
  }

  static getRegionCurrency = () => {
    const currency = this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.japanAbbr ? currencyType.JPY : currencyType.USD
    return currency
  }

  static getHelpPageURL = () => {
    const apacHelp = HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + "apac/about-avnet/online-help/"
    const japanHelp = HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + "japan/about-avnet/online-help/shop"
    const url = this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.apacAbbr ? apacHelp : japanHelp
    return url
  }

  static getTermsAndConditionURL() {
    const url = HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + this.avUserInfoData.speedBoatNameLower + '/about-avnet/legal/'
    return url
  }

  static pathNameCookie = this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.apacAbbr ? "pathNameApac" : "pathNameJapan"

  static daysToWeeksAndDays = (days) => {
    const weeks = Math.floor(days / 7);
    const remainingDays = days % 7;
    return `${weeks + (weeks === 1 ? ` ${System.translation('week')}` : ` ${System.translation('weeks')}`)} ${remainingDays ? remainingDays + (remainingDays === 1 ? ` ${System.translation('day')}` : ` ${System.translation('days')}`) : ''}`;
  };

  static getTrackingLink(carrierMethod) {
    const carrierUrls = {
      'YAMATO': 'http://toi.kuronekoyamato.co.jp/cgi-bin/tneko',
      'Yamato Transport': 'http://toi.kuronekoyamato.co.jp/cgi-bin/tneko',
    };

    return carrierUrls[carrierMethod] || '';
  }

  static toBoolean = (value) => {
    if (typeof value === 'string') {
      return ['yes', 'y', 'true', '1'].includes(value.toLowerCase());
    }
    return value === true || value === 1;
  };

  static getCountryCode = () => {
    const pair = Cookies.get(this.storageName.User_Country)?.split(',').find(pair => pair.split('=')[0] === 'country_code');
    return pair ? pair.split('=')[1] : null;
  };

  static getCurrentCartCount = () => {
    return Cookies.get(System.getCartCount()) ? Cookies.get(System.getCartCount()) : 0;
  };

  static getSessionId = () => {
    return this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.japanAbbr ? this.storageName.GUEST_SESSION_ID_JP : this.storageName.GUEST_SESSION_ID_AP
  };

  static getGuestBomId = () => {
    return this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.japanAbbr ? this.storageName.GUEST_BOM_ID_JP : this.storageName.GUEST_BOM_ID_AP
  };

  static getCartId = () => {
    return this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.japanAbbr ? this.storageName.CART_ID_JP : this.storageName.CART_ID_AP
  };
  static getCartCount = () => {
    return this.avUserInfoData.speedBoatAbbr === Constants.speedBoats.japanAbbr ? this.storageName.CART_COUNT_JP : this.storageName.CART_COUNT_AP
  };

  static getZipCodeLength = (countryCode = "") => {
    const zipLengths = {
      JP: 7,
      CN: 6, SG: 6, VN: 6,
      ID: 5, MY: 5, TH: 5, DE: 5, FR: 5,
      PH: 4,
      US: 10,
      GB: 9,
    };

    return zipLengths[countryCode.toUpperCase()] || 10;
  };

  static validatePostalCode = (postalCode = "", countryCode = "") => {
    const postalCodePatterns = {
      JP: /^[0-9]{7}$/,
      CN: /^[0-9]{6}$/,
      SG: /^[0-9]{6}$/,
      VN: /^[0-9]{1,6}$/,
      ID: /^[0-9]{5}$/,
      TH: /^[0-9]{5}$/,
      MY: /^[0-9]{5}$/,
      DE: /^[0-9]{5}$/,
      FR: /^[0-9]{5}$/,
      PH: /^[0-9]{4}$/,
      GB: /^.{1,9}$/,
      US: /(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)/,
    };

    const zipcode = postalCode.trim();
    const country = countryCode.toUpperCase();

    if (postalCodePatterns[country]) {
      return postalCodePatterns[country].test(zipcode);
    }

    return zipcode.length <= 10;
  }
}

export default System;
